import React from 'react';

import { Button } from '../../ui/button';

interface RemoveButtonProps {
  onClick: () => void;
  className?: string;
  children?: React.ReactNode;
}

const RemoveButton: React.FC<RemoveButtonProps> = ({
  onClick,
  className = 'absolute top-2 right-2',
  children = 'Remove',
}) => {
  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      onClick={onClick}
      tabIndex={0}
      className={`text-xs px-2 py-1 text-red-600 hover:text-red-700 hover:bg-red-50 ${className}`}
    >
      {children}
    </Button>
  );
};

export default RemoveButton;
